module.exports = __webpack_public_path__ + "3010e3cb343fbd25ce54788f58e75c43.png";